import { takeLatest } from 'redux-saga/effects'
import {
  broadcastNotification,
  fetchProductListByIds,
  tryFetchScheduledNotification,
  tryDeleteScheduledNotification,
  tryScheduleNotification,
  tryUpdateScheduleNotification,
  tryGetRecieverCount,
  tryFetchBulkNotification
} from '../slices/notificationSlice'
import {
  handleBroadCastNotification,
  handleGetScheduledNotification,
  handleGetProductListByProductIds,
  handleDeleteNotification,
  handleScheduleNotification,
  handleUpdateScheduleNotification,
  handleGetReceiverCount,
  handleGetBulkNotification,
} from './handlers/notificationHandler';

const notificationSaga = [
  takeLatest(broadcastNotification.type, handleBroadCastNotification),
  takeLatest(tryFetchScheduledNotification.type, handleGetScheduledNotification),
  takeLatest(fetchProductListByIds.type, handleGetProductListByProductIds),
  takeLatest(tryDeleteScheduledNotification.type, handleDeleteNotification),
  takeLatest(tryScheduleNotification.type, handleScheduleNotification),
  takeLatest(tryUpdateScheduleNotification.type, handleUpdateScheduleNotification),
  takeLatest(tryGetRecieverCount.type, handleGetReceiverCount),
  takeLatest(tryFetchBulkNotification.type, handleGetBulkNotification),
]

export default notificationSaga
